<div class="container-fluid">
    <div class="row">
        <ul class="breadcrumb">
            <li><strong>Onde estou:</strong></li>
            <li class="active">
                <span>Venda Arla - Gerenciar Postos</span>
            </li>
        </ul>




        <mat-grid-list cols="4" rowHeight="4:1">

            <mat-grid-tile [colspan]="4" [rowspan]="1">
                <mat-toolbar color="primary" class="mat-elevation-z3">
                    <span>Lista de postos </span>
                    <span class="spacer"></span>
                </mat-toolbar>
            </mat-grid-tile>


            <mat-grid-tile [colspan]="2" [rowspan]="1">
                <mat-form-field class="fullWidth">
                    <mat-label style="padding-left: 5px;">Pesquisar por Cod. ou nome do Posto</mat-label>
                    <input matInput placeholder="Buscar por posto ou nome do posto"
                        (keyup)="buscaTokenInputPosto(busca.value)" #busca>
                </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile [colspan]="1" [rowspan]="1">
                <mat-form-field class="fullWidth">
                    <mat-label style="padding-left: 5px;">Filtrar por Estado</mat-label>
                    <mat-select (valueChange)="filtrarPorEstado($event)">
                        <mat-option value="todos">Todos Estados</mat-option>
                        <mat-option *ngFor="let e of estados" [value]="e">{{e}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile [colspan]="1" [rowspan]="1">
                <mat-form-field class="fullWidth">
                    <mat-label style="padding-left: 5px;">Filtrar pela Cidade</mat-label>
                    <mat-select (valueChange)="filtrarPorCidade($event)">
                        <mat-option value="todos">Todas Cidades</mat-option>
                        <mat-option *ngFor="let e of cidades" [value]="e">{{e}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile [colspan]="2" [rowspan]="1" class="todos">
            </mat-grid-tile>

            <mat-grid-tile [colspan]="2" [rowspan]="1" class="todos">
                <input type="submit" value="Autorizar venda de Arla em todos?" class="btn btn-default"
                    (click)="liberarArlaEmTodos(true);" />
                <input type="submit" value="Bloquear venda de Arla em todos?" class="btn btn-default"
                    (click)="liberarArlaEmTodos(false);" />
            </mat-grid-tile>






        </mat-grid-list>






        <!-- <div class="col-3">

        <mat-form-field class="fullWidth">
            <mat-label style="padding-left: 5px;">Filtrar por Estado</mat-label>
            <mat-select (valueChange)="filtrarPorEstado($event)">
                <mat-option value="todos">Todos Estados</mat-option>
                <mat-option *ngFor="let e of estados" [value]="e">{{e}}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div class="col-3">
        <mat-form-field class="fullWidth">
            <mat-label style="padding-left: 5px;">Filtrar pela Cidade</mat-label>
            <mat-select (valueChange)="filtrarPorCidade($event)">
                <mat-option value="todos">Todas Cidades</mat-option>
                <mat-option *ngFor="let e of cidades" [value]="e">{{e}}</mat-option>
            </mat-select>
        </mat-form-field>
    </div> -->






    </div>








    <!-- <div class="row pull-right">
    <div class="col-12 ">
        <input type="submit" value="Autorizar venda de Arla em todos?" class="btn btn-default"
            (click)="liberarArlaEmTodos(true);" />
        <input type="submit" value="Bloquear venda de Arla em todos?" class="btn btn-default"
            (click)="liberarArlaEmTodos(false);" />
    </div>
</div> -->


    <div class="tableContainer">
        <table mat-table matSort (matSortChange)="sortData($event)" [dataSource]="dataSource"
            class="mat-elevation-z3 fullWidth">
            <ng-container matColumnDef="posto">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Posto</th>
                <td mat-cell *matCellDef="let item"> # {{ item.codigoPosto }} </td>
            </ng-container>
            <ng-container matColumnDef="nome_posto">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Nome do Posto</th>
                <td mat-cell *matCellDef="let item"> {{ item.nomePosto }} </td>
            </ng-container>
            <ng-container matColumnDef="cidade">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Cidade</th>
                <td mat-cell *matCellDef="let item"> {{ item.cidade }} </td>
            </ng-container>

            <ng-container matColumnDef="estado">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>UF</th>
                <td mat-cell *matCellDef="let item"> {{ item.estado }} </td>
            </ng-container>

            <ng-container matColumnDef="endereco">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Endereço</th>
                <td mat-cell *matCellDef="let item"> {{ item.endereco }} </td>
            </ng-container>



            <ng-container matColumnDef="vendaArlaAutorizado" align="center">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Venda de Arla Autorizado? </th>
                <td mat-cell *matCellDef="let item" align="center">
                    <mat-checkbox (change)="gerenciarVendaArla($event, item)" [(ngModel)]="item.vendaArlaPermitida"
                        color="primary">
                    </mat-checkbox>
                </td>
            </ng-container>



            <tr mat-header-row *matHeaderRowDef="colsAndRows"></tr>
            <tr mat-row *matRowDef="let row; columns: colsAndRows"></tr>
        </table>




        <ng-container>
            <!-- <td *ngIf="loading" class="mat-cell-load" id="loading">
            <mat-progress-spinner mode="indeterminate" class="table-progressbar" color="accent"></mat-progress-spinner>
            <h3>Buscando dados...</h3>
        </td> -->
            <td *ngIf="!loading" class="mat-cell">
                <h3 *ngIf="dataSource.data.length < 1">
                    Nao foi encontrado nenhum dado!
                </h3>
            </td>
        </ng-container>


    </div>
    <div class="inputContainer" style="padding-top: 15px;">
        <mat-paginator [pageSize]=30 [pageSizeOptions]="[30, 50, 100]"></mat-paginator>
    </div>


    <div class="modal" id="carregando" tabindex="-1" [hidden]="!loading">
        <div class="modal-dialog">
            <div class="modal-content">

                <div class="modal-body corpo-spinner">
                    <div class="spinner-border" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                    <h2>
                        Carregando dados...
                    </h2>
                </div>

            </div>
        </div>
    </div>
</div>